/**
 * Câu hỏi thống kê đa chỉ tiêu theo khu vực thu phí → ép vòng LLM đầu gọi
 * get_toll_area_statistics (tool_choice), tránh trả lời bịa số.
 */
export function shouldForceGetTollAreaStatistics(userInput: string): boolean {
  const t = userInput.trim();

  // Chỉ cần danh sách / tên mã khu, không cần bảng số liệu
  const listOnly =
    /(danh sách|liệt kê|có những khu|khu nào|mã khu nào|tên khu)/i.test(t) &&
    !/(thống kê|tổng hợp|lượng nước|m³|m3|doanh thu|số khách|số liệu|báo cáo|tiêu thụ)/i.test(
      t
    );
  if (listOnly) return false;

  const statsIntent =
    /(thống kê|tổng hợp|báo cáo|số liệu|tình hình)/i.test(t) ||
    /lượng nước|tiêu thụ/i.test(t) ||
    /doanh thu/i.test(t) ||
    /(khách hàng|hóa đơn|hoá đơn).{0,40}(khu|khu vực)/i.test(t) ||
    /(khu|khu vực).{0,40}(khách|hóa đơn|hoá đơn|nước|lượng)/i.test(t);

  const byArea =
    /(theo khu|theo từng khu|khu vực|từng khu|mỗi khu|các khu|từng khu vực|mỗi khu vực)/i.test(
      t
    );

  if (statsIntent && byArea) return true;
  if (/lượng nước|tiêu thụ/i.test(t) && byArea) return true;
  if (/doanh thu/i.test(t) && byArea) return true;

  return false;
}

export const FORCED_TOLL_AREA_STATISTICS_CHOICE = {
  type: "function" as const,
  function: { name: "get_toll_area_statistics" },
};
